import { Web3Provider } from "@ethersproject/providers";
import { RpcProvider } from "./RpcProvider";
export class ExtProvider extends Web3Provider {
    async estimateGas(transaction) {
        return RpcProvider.estimateGas(this, await super.estimateGas(transaction), transaction);
    }
}
